{
  "nl": {
    "fileSharing": {
      "public": {
        "empty": {
          "title": "Nog geen bestanden",
          "description": "In deze gedeelde ruimte zijn nog geen bestanden."
        }
      }
    }
  }
}
